import {PageData} from "../../objects/Page";
import {getOneByID} from "./resource";

export const apiUrlPages = '/v2/pages/'

export const getPageDataById = (path: string, props: object | null): Promise<PageData> => {
  return getOneByID(apiUrlPages, path, props)
}
